module.exports = __webpack_public_path__ + "media/assets/icons/manabu-icon-47901743b35ac0b07ccdeac98f4b2e8b.svg";